import { toolboxApi, unwrapResult } from '~/modules/query/base';

/** One container row from GET /service-manager. */
export interface ServiceRecord {
  [key: string]: unknown;
  name?: string;
  host?: string;
  image?: string;
  status?: string;
  health?: string;
  serviceName?: string;
}

/** GET /service-manager */
export interface ServiceListResult {
  [key: string]: unknown;
  data: ServiceRecord[];
}

/** GET /service-manager/stats — counters keyed by stat name. */
export interface ServiceStats {
  [key: string]: unknown;
}

/** GET /service-manager/hosts */
export interface ServiceHostsResult {
  [key: string]: unknown;
  distinctHosts?: string[];
}

/** POST /service-manager body: the quick action to run on a service (Move, Update, Remove, ...). */
export interface QuickActionRequest {
  [key: string]: unknown;
}

/** Result of a quick action. */
export interface QuickActionResult {
  [key: string]: unknown;
}

export const servicesApi = toolboxApi.injectEndpoints({
  endpoints: (builder) => ({
    getServices: builder.query<ServiceListResult, void>({
      query: () => ({ url: '/service-manager', method: 'GET' }),
      transformResponse: unwrapResult<ServiceListResult>,
      providesTags: ['Service'],
    }),
    getServiceStats: builder.query<ServiceStats, void>({
      query: () => ({ url: '/service-manager/stats', method: 'GET' }),
      transformResponse: unwrapResult<ServiceStats>,
      providesTags: ['ServiceStats'],
    }),
    getDistinctHosts: builder.query<ServiceHostsResult, void>({
      query: () => ({ url: '/service-manager/hosts', method: 'GET' }),
      transformResponse: unwrapResult<ServiceHostsResult>,
      providesTags: ['ServiceHost'],
    }),
    runQuickAction: builder.mutation<QuickActionResult, QuickActionRequest>({
      query: (body) => ({ url: '/service-manager', method: 'POST', data: body }),
      transformResponse: unwrapResult<QuickActionResult>,
      invalidatesTags: ['Service', 'ServiceStats', 'ServiceHost'],
    }),
  }),
});

export const {
  useGetServicesQuery,
  useGetServiceStatsQuery,
  useGetDistinctHostsQuery,
  useRunQuickActionMutation,
} = servicesApi;
